'use strict';

$.fn.setSameHeightOnContent = function (childrenSelector) {
	var $cols = $(this).children(childrenSelector);
	var numberOfCols = $cols.length;

	if (numberOfCols === 0) {
		return;
	}

	// number of content elements of each column
	var numberOfContents = $cols.map(function () {
		return $(this).children().length;
	});

	// maximal number of content elements of all columns
	var maxNumberOfContents = Math.max.apply(null, numberOfContents);

	var currentContentIndex = 1;
	while (currentContentIndex < maxNumberOfContents) {
		var $contents = $cols.children('.frame:nth-child(' + currentContentIndex + ')');

		// calculate maximal height
		var heights = $contents.map(function () {
			$(this).height('auto');
			return $(this).height();
		});
		var maxHeight = Math.max.apply(null, heights);

		// set maximal height to each content-element on the same level
		$contents.each(function () {
			var $element = $(this);
			var ignoreSettingHeight = false;
			var listOfClassesToPreventSettingHeight = ['ignore-parent-has-same-height', 'dropdown-wrap', 'frame-type-container-dropdownbox','frame-type-container-dropdownboxinsidecontentbox'];
			listOfClassesToPreventSettingHeight.forEach(function (className) {
				if (ignoreSettingHeight === false) {
					ignoreSettingHeight = $element.hasClass(className);
				}
			})
			if (ignoreSettingHeight) {
				return;
			}
			$element.height(maxHeight);
		})

		currentContentIndex++;
	}

}

$.fn.removeSameHeightOnContent = function (childrenSelector) {
	var $cols = $(this).children(childrenSelector);
	$cols.each(function () {
		var $contents = $(this).children('.frame');
		$contents.each(function () {
			$(this).height('auto');
		})
	})
}

$(window).on('load', function (e) {

	// set grid content to same height
	$('.gridwrap.content-has-same-height').each(function (index, gridwrap) {

		if (window.innerWidth > breakpointTablet) {
			$(gridwrap).setSameHeightOnContent('.gridcol');
		}

		var hasAutoHeight = window.innerWidth <= breakpointTablet;

		$(window).on('resize', function () {
			if (window.innerWidth <= breakpointTablet) {
				if (!hasAutoHeight) {
					$(gridwrap).removeSameHeightOnContent('.gridcol');
				}
				hasAutoHeight = true;
			} else {
				$(gridwrap).setSameHeightOnContent('.gridcol');
				hasAutoHeight = false;
			}
		});
	});

})
